import { IconButton } from '@plato/ui/candidates/icon-button';
import type { FC } from 'react';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { AiChatIcon } from '../assets/ai-chat-icon.tsx';
import { useAskPlato } from './ask-plato-provider.tsx';

/**
 * Mobile entry point, sitting in the top bar beside global search — the two
 * read as siblings there: "look something up" and "ask about it".
 *
 * On desktop the entry point is `AskPlatoFab` instead.
 */
export const AskPlatoTrigger: FC = () => {
    const { t } = useLocale();
    const { toggleAskPlato } = useAskPlato();

    return (
        <IconButton
            label={t('ask_plato__trigger')}
            variant="primary"
            intent="ai"
            onClick={() => {
                toggleAskPlato('top_bar');
            }}
        >
            {/* default h-4, the same 16px as the neighboring top-bar/menu icons */}
            <AiChatIcon className="shrink-0" />
        </IconButton>
    );
};
